'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _matchPath = require('react-router/matchPath');

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransitionSwitch = function (_React$Component) {
  (0, _inherits3.default)(TransitionSwitch, _React$Component);

  function TransitionSwitch() {
    (0, _classCallCheck3.default)(this, TransitionSwitch);
    return (0, _possibleConstructorReturn3.default)(this, (TransitionSwitch.__proto__ || (0, _getPrototypeOf2.default)(TransitionSwitch)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransitionSwitch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      (0, _invariant2.default)(this.context.router, 'You should not use <TransitionSwitch> outside a <Router>');
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      (0, _warning2.default)(!(nextProps.location && !this.props.location), '<TransitionSwitch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

      (0, _warning2.default)(!(!nextProps.location && this.props.location), '<TransitionSwitch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    }
  }, {
    key: 'render',
    value: function render() {
      var route = this.context.router.route;
      var _props = this.props,
          children = _props.children,
          render = _props.render,
          component = _props.component;

      var location = this.props.location || route.location;

      var match = void 0,
          child = void 0;
      _react2.default.Children.forEach(children, function (element) {
        if (!_react2.default.isValidElement(element)) return;

        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        if (match == null) {
          child = element;
          match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
        }
      });

      var routeElement = match ? _react2.default.cloneElement(child, {
        location: location,
        computedMatch: match,
        key: child.key != null ? child.key : match.url
      }) : null;

      var props = { location: location, match: match, children: routeElement };
      if (component) return _react2.default.createElement(component, props);
      if (render) return render(props);
      return routeElement;
    }
  }]);
  return TransitionSwitch;
}(_react2.default.Component);

TransitionSwitch.contextTypes = {
  router: _propTypes2.default.shape({
    route: _propTypes2.default.object.isRequired
  }).isRequired
};
TransitionSwitch.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.object
};
exports.default = TransitionSwitch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-transition-switch/lib/index.js
// module id = 2062
// module chunks = 0